<template>
  <div>
    <b-card title="Grupos de tipos de relatórios">
      <b-button
        class="btn-sm btn-nav-link btn-nav-link-white"
        size="sm"
        variant="flat-primary"
        :to="{ name: 'admin-reportTypeGroups-register' }"
      >
        <feather-icon icon="PlusIcon" />
        {{ $t('ADM_PAGES').Add }}
      </b-button>
      <b-button
      class="btn-sm btn-nav-link btn-nav-link-white"
      size="sm"
      variant="flat-primary"
      @click="reportData"
    >
      <feather-icon icon="FileTextIcon" />
      {{ $t('ADM_PAGES').Export }}
    </b-button>
      <custom-g-table
        v-if="displayTable"
        :displayLoading="tableLoading"
        :fields="fields"
        :items="data"
        :hasEditButton="true"
        :hasDeleteButton="false"
        :totalRows="totalRows"
        :limit="limit"
        @changePage="onChangePage"
        @onEdit="onEdit"
        @onDelete="onDelete"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
      />
    </b-card>
  </div>
</template>

<script>
import { BButton, BCard } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import reportTypeGroupsService from "@/providers/reportTypeGroupsService";
import AppConstants from "@/appConstants";
import messageDialogHelper from '@/helpers/message-dialog-helper';
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BCard,
    BButton,
    CustomGTable,
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      data: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      filter: {},
      tableLoading: true,
      fields: [
        { field: "action_buttons", label: this.$t('ADM_PAGES').Actions, sortable: false },
        { field: "name", label: this.$t('ADM_PAGES').Name, sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: this.$t('ADM_PAGES').SearchByName, trigger: 'enter' } },
        { field: "code", label: this.$t('ADM_PAGES').Code, sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: this.$t('ADM_PAGES').SearchByCode, trigger: 'enter' } },
        { field: "dt_create", label: this.$t('ADM_PAGES').Creation, type: "custom_date", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: this.$t('ADM_PAGES').SearchByDate, trigger: 'enter' } },
        { field: "active", label: this.$t('ADM_PAGES').Enabled, type: "boolean", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: this.$t('ADM_PAGES').SearchByActive, filterDropdownItems: [{value: true, text: this.$t('ADM_PAGES').Yes}, {value: false, text: this.$t('ADM_PAGES').No}] } },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", this.$t('ADM_PAGES').ReportTypeGroups);
    this.setInitialTableFilters();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append('page', this.page);
      params.append('limit', this.limit);
      
      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }
      return params;
    },
  },
  methods: {
    setInitialTableFilters() {
      Object.keys(this.urlQuery).forEach(item => {
        this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      });
      this.loadData();
    },
    reportData() {
      const params = this.searchParams;
      params.append("download", true);
      reportTypeGroupsService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", 'grupos_tipo_relatorio.xlsx');
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      // this.filter = data;
      // console.log('OnFilter: ', this.filter);
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    onEdit(data) {
      this.$router.push(
        `${AppConstants.NAVIGATION_PAGE_ADM_REPORT_TYPE_GROUPS_REGISTER}/${data._id}`
      );
    },
    onDelete(data) {
      // console.log(data);
      const params = new URLSearchParams();
      reportTypeGroupsService
        .deleteReportTypeGroup(data._id, params)
        .then(() => {
          console.log("deleted");
          messageDialogHelper.displayDeleteDataMessage(()=> {
            this.loadData();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      this.tableLoading = true;
      onlyLatestRequest(this, 'loadData', reportTypeGroupsService.getAllReportTypeGroups(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.tableLoading = false;
          this.data = res.data;
          this.totalRows = res.totalRows;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style>
</style>